import styled from 'styled-components';
import { Link } from 'react-router-dom';

const Wrap = styled.div`
  min-height: 100vh;
  display: grid;
  place-items: center;
  gap: 12px;
  text-align: center;
  font-family: ${({ theme }) => theme.font.body};
  color: ${({ theme }) => theme.color.textMuted};
  /* Opaque when glass is OFF so the 404 screen doesn't bleed the animated backdrop. */
  background: ${({ theme }) => (theme.cardsGlass ? 'transparent' : theme.color.bgRoot)};
`;

const Heading = styled.h2`
  margin: 0;
  font-family: ${({ theme }) => theme.font.display};
  color: ${({ theme }) => theme.color.textPrimary};
`;

export function NotFound() {
  return (
    <Wrap>
      <div>
        <Heading>404: lost signal</Heading>
        <Link to="/">Back to start</Link>
      </div>
    </Wrap>
  );
}
